import { StringKey } from '../../../../lang/index';

export enum GrantAgreementBaseField {
  ADDRESS = 'address',
  COMPANY_IDENTIFIER = 'company-identifier',
  COMPANY_NAME = 'company-name',
  GRANT_AMOUNT = 'grant-amount',
  GRANT_DATE = 'grant-date',
  INCORPORATION_COUNTRY = 'incorporation-country',
  NATIONALITY = 'nationality',
  PASSPORT_NUMBER = 'passport-number',
  PLAN_NAME = 'plan-name',
  PLAN_TYPE = 'plan-type',
  STAKEHOLDER_EMAIL = 'stakeholder-email',
  STAKEHOLDER_NAME = 'stakeholder-name',
  VESTING_TYPE = 'vesting-type',
}

export const grantAgreementBaseFieldLabelKey: Record<GrantAgreementBaseField, StringKey> = {
  [GrantAgreementBaseField.ADDRESS]: 'ADDRESS',
  [GrantAgreementBaseField.COMPANY_NAME]: 'COMPANY_NAME',
  [GrantAgreementBaseField.COMPANY_IDENTIFIER]: 'COMPANY_IDENTIFIER',
  [GrantAgreementBaseField.GRANT_AMOUNT]: 'GRANT_AMOUNT',
  [GrantAgreementBaseField.GRANT_DATE]: 'GRANT_DATE',
  [GrantAgreementBaseField.INCORPORATION_COUNTRY]: 'INCORPORATION_COUNTRY',
  [GrantAgreementBaseField.NATIONALITY]: 'NATIONALITY',
  [GrantAgreementBaseField.PASSPORT_NUMBER]: 'PASSPORT_NO',
  [GrantAgreementBaseField.PLAN_NAME]: 'PLAN_NAME',
  [GrantAgreementBaseField.PLAN_TYPE]: 'PLAN_TYPE',
  [GrantAgreementBaseField.STAKEHOLDER_EMAIL]: 'STAKEHOLDER_EMAIL',
  [GrantAgreementBaseField.STAKEHOLDER_NAME]: 'STAKEHOLDER_NAME',
  [GrantAgreementBaseField.VESTING_TYPE]: 'VESTING_TYPE',
};

export enum GrantPlanTypeField {
  HURDLE_VALUE = 'hurdle-value',
  RSA_PURCHASE_PRICE = 'rsa-purchase-price',
  STRIKE_PRICE = 'strike-price',
  WARRANT_PRICE = 'warrant-price',
}

export const grantPlanTypeFieldLabelKey: Record<GrantPlanTypeField, StringKey> = {
  [GrantPlanTypeField.HURDLE_VALUE]: 'HURDLE_VALUE',
  [GrantPlanTypeField.RSA_PURCHASE_PRICE]: 'RSA_PURCHASE_PRICE',
  [GrantPlanTypeField.STRIKE_PRICE]: 'STRIKE_PRICE',
  [GrantPlanTypeField.WARRANT_PRICE]: 'WARRANT_PRICE',
};

export enum VestingTimeBasedStandardField {
  ACCELERATION_DATE = 'acceleration-date',
  CLIFF = 'cliff',
  VESTING_DURATION = 'vesting-duration',
  VESTING_FREQUENCY = 'vesting-frequency',
  VESTING_ON = 'vesting-on',
}

export const vestingTimeBasedStandardFieldLabelKey: Record<
  VestingTimeBasedStandardField,
  StringKey
> = {
  [VestingTimeBasedStandardField.ACCELERATION_DATE]: 'ACCELERATION_DATE',
  [VestingTimeBasedStandardField.CLIFF]: 'CLIFF',
  [VestingTimeBasedStandardField.VESTING_DURATION]: 'VESTING_DURATION',
  [VestingTimeBasedStandardField.VESTING_FREQUENCY]: 'VESTING_FREQUENCY',
  [VestingTimeBasedStandardField.VESTING_ON]: 'VESTING_ON',
};

export enum VestingTimeBasedDynamicField {
  ACCELERATION_DATE = 'acceleration-date',
  PERIOD_N_ALLOCATION = 'period-n-allocation',
  PERIOD_N_DURATION = 'period-n-duration',
  PERIOD_N_FREQUENCY = 'period-n-frequency',
  VESTING_ON = 'vesting-on',
}

export const vestingTimeBasedDynamicFieldLabelKey: Record<VestingTimeBasedDynamicField, StringKey> =
  {
    [VestingTimeBasedDynamicField.ACCELERATION_DATE]: 'ACCELERATION_DATE',
    [VestingTimeBasedDynamicField.PERIOD_N_ALLOCATION]: 'PERIOD_N_ALLOCATION',
    [VestingTimeBasedDynamicField.PERIOD_N_DURATION]: 'PERIOD_N_DURATION',
    [VestingTimeBasedDynamicField.PERIOD_N_FREQUENCY]: 'PERIOD_N_FREQUENCY',
    [VestingTimeBasedDynamicField.VESTING_ON]: 'VESTING_ON',
  };

export enum VestingTargetBasedField {
  MILESTONE_N_NAME = 'milestone-n-name',
  MILESTONE_N_TARGET_DATE = 'milestone-n-target-date',
  MILESTONE_N_WEIGHT = 'milestone-n-weight',
}

export const vestingTargetBasedFieldLabelKey: Record<VestingTargetBasedField, StringKey> = {
  [VestingTargetBasedField.MILESTONE_N_NAME]: 'MILESTONE_N_NAME',
  [VestingTargetBasedField.MILESTONE_N_TARGET_DATE]: 'MILESTONE_N_TARGET_DATE',
  [VestingTargetBasedField.MILESTONE_N_WEIGHT]: 'MILESTONE_N_WEIGHT',
};
